module.exports = __webpack_public_path__ + "static/assets/506569d9a49ee2ca95d99c2a6d588f0d.svg";